<!--
 * @Description: 
 * @Author: 诺
 * @Date: 2022-04-28 10:20:30
 * @LastEditors: 诺
 * @LastEditTime: 2022-12-02 14:32:24
-->
<template>
  <div class="btn_home act-text-stroke"  @click="$goPage(url || 'index', $route.query)">
    <!-- <img src="http://assets.rurushishi.com/activies/yy-help-2022-12/goBack.png"/> -->
    <img src="http://assets.rurushishi.com/activies/yy-act-202409/goBack.png"/>
  </div>
</template>

<script>
export default {
  components: {},
  props: ["bColor", "textColor",'url'],
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="css" scoped>
.btn_home {
  position: fixed;
  bottom: 55px;
  right: 5px;
  z-index: 100;
  width: 69px;
  height: 69px;
  border-radius: 24px;
  font-size: 14px;
  line-height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn_home > img {
  width: 100%;
}
</style>